var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOverviewBtnArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "17px",
    viewBox: "0 0 12 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pages",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "home",
    transform: "translate(-1811.000000, -1038.000000)",
    stroke: "#04B7EC",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("g", {
    id: "components/feedback",
    transform: "translate(1494.000000, 1010.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "CLICK_showFeedbackPage",
    transform: "translate(0.213350, 0.322450)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "arrow",
    points: "319.03665 29.21 325.75415 35.9275 319.03665 42.645"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverviewBtnArrow);
export default __webpack_public_path__ + "static/media/overview-btn-arrow.039de83e8be7f7f9d6738d6c03585791.svg";
export { ForwardRef as ReactComponent };